export const loanBalanceCalcFunction = (baseAmt, interest, payment, loanTerm, monthsRemaining) => {

     /*
          FV = PV(1+r)^n - P((1+r)^n - 1 / r)
          where:
               FV = remaining balance of loan
               PV = original amount of loan (baseAmt)
               P = monthly payment (payment)
               r = interest rate - (interest)
               n = number of payments made   ((loan Term * 12) - monthsRemaining) 
                   this is the monthsPaid 
          */

        
     let outstandingLoanAmt = 0;
     const r = interest / 12; // Convert annual interest rate to monthly
     const monthsPaid = (loanTerm * 12) - monthsRemaining;
     
     if (loanTerm === monthsRemaining){
          outstandingLoanAmt = baseAmt;
     }else{
          // Avoid division by zero if interest rate is 0
          if (r === 0) {
               outstandingLoanAmt = baseAmt - payment * (loanTerm - monthsPaid);
          }else{
               const growthFactor = Math.pow(1 + r, monthsPaid);
               const paymentFactor = payment * ( (growthFactor - 1) / r );
               outstandingLoanAmt = baseAmt * growthFactor - paymentFactor;
              // outstandingLoanAmt =
              //      baseAmt * Math.pow(1 + r, n) -
              //      payment * ((Math.pow(1 + r, n) - 1) / r);
          }
     }
     return outstandingLoanAmt;
 }
